import { ReactNode } from "react";

import {
	Control,
	Controller,
	FieldPath,
	FieldValues,
	Path,
	RegisterOptions,
} from "react-hook-form";
import { Checkbox, Typography } from "@mui/material";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";

import { getFormError } from "../../../utils";

import "./common_checkbox.scss";

export type TCommonCheckboxProps<T extends FieldValues> = {
	control: Control<T>;
	name: Path<T>;
	label: string | ReactNode;
	rules?: Omit<
		RegisterOptions<T, FieldPath<T>>,
		"valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
	>;
};

export default function CommonCheckbox<T extends FieldValues>({
	control,
	name,
	label,
	rules,
}: TCommonCheckboxProps<T>) {
	return (
		<Controller
			control={control}
			name={name}
			rules={rules}
			render={({ field: { value, onChange }, formState: { errors } }) => {
				const errorMessage = getFormError(name, errors);

				let className = "";
				if (errorMessage) {
					className += " invalid";
				}

				return (
					<div className="common-checkbox-container">
						<div className="common-checkbox">
							<Checkbox
								checked={value}
								className={className}
								onChange={onChange}
								icon={<MdCheckBoxOutlineBlank className="normal-icon" />}
								checkedIcon={
									<MdCheckBox className="normal-icon" color={errorMessage} />
								}
							/>
							<Typography component="span" className="normal-text">
								{label}
							</Typography>
						</div>
						{errorMessage && (
							<Typography component="div" className="invalid-message">
								{errorMessage}
							</Typography>
						)}
					</div>
				);
			}}
		/>
	);
}
